import React, { useState } from 'react'

import { Button, Modal, Header } from 'components/elements'
import EmailAuthScreen from 'components/auth/register/confirmEmail/resendEmailAuth'
import { EMAIL, PHONE } from '../../account/infoWizard/main/constants'
import { SCREENS } from '../../account/infoWizard/screens/screens'
import PhoneScreen from 'components/auth/register/phone/phoneScreen'
import { getVerificationTitleAndCtaText } from '../utils'

export default function VerifyEmailPhoneModal(props) {
  const [showEmailVerification, setShowEmailVerification] = useState(false)
  const [showPhoneVerification, setShowPhoneVerification] = useState(false)

  const {
    isVerificationModalOpen,
    isMobile,
    handleModalClose,
    userVerificationInfo,
    handlePhoneVerified,
    onComplete,
    showClose = true,
    closeOnBlur = true,
    closeOnEsc = true,
  } = props

  const handleVerifyClick = () => {
    if (!userVerificationInfo.phoneVerified) {
      setShowPhoneVerification(true)
    } else if (!userVerificationInfo.emailVerified) {
      setShowEmailVerification(true)
    }
  }

  const onPhoneSuccess = () => {
    handlePhoneVerified()
    if (!userVerificationInfo.emailVerified) {
      setShowPhoneVerification(false)
      return setShowEmailVerification(true)
    }
    onComplete()
    handleModalClose()
  }

  const onEmailDone = () => {
    handleModalClose()
  }

  const { title, cta } = getVerificationTitleAndCtaText(userVerificationInfo)

  return (
    <Modal
      show={isVerificationModalOpen}
      onClose={handleModalClose}
      showClose={showClose}
      closeOnBlur={closeOnBlur}
      closeOnEsc={closeOnEsc}
    >
      <div className="pb-2 content">
        {!showEmailVerification && !showPhoneVerification && (
          <>
            <Header
              renderAs="h2"
              size={4}
              className="has-text-weight-bold mb-4 mt-0"
            >
              {title}
            </Header>
            <p>
              To activate chat, you must have a verified email and cell phone
              number with Twisted Road.
            </p>
            <div className="has-text-centered">
              <Button
                color="primary"
                className={`is-medium has-text-weight-bold ${
                  isMobile ? 'is-fullwidth' : ''
                }`}
                onClick={handleVerifyClick}
              >
                {cta}!
              </Button>
            </div>
          </>
        )}

        {showPhoneVerification && !userVerificationInfo.phoneVerified && (
          <PhoneScreen
            {...SCREENS[PHONE]}
            skippable={false}
            onSuccess={onPhoneSuccess}
          />
        )}

        {showEmailVerification && !userVerificationInfo.emailVerified && (
          <EmailAuthScreen
            {...SCREENS[EMAIL]}
            sendEmailOnLoad
            onComplete={onEmailDone}
          />
        )}
      </div>
    </Modal>
  )
}
